import { eventRefereeConstants } from '../_constants';

const defaultState = {
  loading: false,
  error: false,
  referees: [],
  allReferees: [],
};

export function eventReferee(state = defaultState, action) {
  switch (action.type) {
    case eventRefereeConstants.GET_REFEREES_REQUEST:
      return {
        ...state,
        loading: true,
        referees: [],
      };
    case eventRefereeConstants.GET_REFEREES_SUCCESS:
      return {
        ...state,
        loading: false,
        referees: action.data,
      };
    // add, remove, and list requests
    case eventRefereeConstants.GET_AVAILABLE_REFEREES_REQUEST:
    case eventRefereeConstants.REMOVE_REFEREE_REQUEST:
    case eventRefereeConstants.ADD_REFEREE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case eventRefereeConstants.ADD_REFEREE_SUCCESS:
      const refs = [...state.referees, action.data];

      return {
        ...state,
        loading: false,
        allReferees: state.referees.filter((ref) => ref.id !== action.data.id),
        referees: refs.filter(
          (item, index) => refs.findIndex((r) => r.id === item.id) === index,
        ),
      };

    case eventRefereeConstants.REMOVE_REFEREE_SUCCESS:
      const ref = state.referees.filter(
        (ref) => ref.id === action.data.refereeId,
      );

      return {
        ...state,
        loading: false,
        allReferees: [...state.allReferees, ...ref],
        referees: state.referees.filter(
          (ref) => ref.id !== action.data.refereeId,
        ),
      };
    case eventRefereeConstants.GET_AVAILABLE_REFEREES_FAILURE:
    case eventRefereeConstants.REMOVE_REFEREE_FAILURE:
    case eventRefereeConstants.ADD_REFEREE_FAILURE:
    case eventRefereeConstants.GET_REFEREES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case eventRefereeConstants.GET_AVAILABLE_REFEREES_SUCCESS:
      const allRefs = [...state.allReferees, ...action.data];
      return {
        ...state,
        loading: false,
        allReferees: allRefs.filter(
          (item, index) => allRefs.findIndex((r) => r.id === item.id) === index,
        ),
      };
    default:
      return state;
  }
}
